{
  "sk-SK": {
    "model": {
      "profile": {
        "id": "ID používateľa",
        "userName": "Používateľské meno",
        "email": "E-mailová adresa",
        "emailConfirmed": "E-mailová adresa bola potvrdená.",
        "phoneNumber": "Telefónne číslo",
        "phoneNumberConfirmed": "Telefónne číslo potvrdené.",
        "twoFactorEnabled": "Dvojfaktorové overenie je aktivované.",
        "lockoutEnd": "Koniec obdobia blokovania.",
        "lockoutEnabled": "Funkcia blokovania je povolená.",
        "accessFailedCount": "Počet neúspešných pokusov o prístup.",
        "firstName": "Krstné meno",
        "lastName": "Priezvisko",
        "picture": "Obrázok avatara.",
        "organisationName": "Organizácia",
        "name": "Meno",
        "roles": "Úlohy"
      }
    },
    "profileManager": {
      "column": {
        "emailConfirmed": "Potvrdené"
      },
      "action": {
        "resetPassword.tooltip": "Pošlite používateľovi e-mailom pokyny na obnovenie hesla."
      },
      "message": {
        "resetPassword.success": "Používateľovi bol odoslaný e-mail s pokynmi na zmenu hesla."
      }
    }
  }
}